<template>
  <div data-slot="card-grid" class="grid grid-cols-[repeat(auto-fill,24rem)] gap-3"><slot /></div>
</template>

<script setup lang="ts">
// A row of like cards (sources, integrations), each the same fixed width and
// wrapping to the next row, so a narrow page stacks them.
</script>
